export const BILLING_BRAND_LIST_QUERY_KEY = ["billing-brand-list"];
export const BILLING_BRAND_DETAILS_QUERY_KEY = (id: string) => [
  "billing-brand-details",
  id,
];
export const BILLING_BRAND_FACETS_QUERY_KEY = ["billing-brand-facets"];
